import React from 'react';
import PropTypes from 'prop-types';
import DataFileUploadPanel from "shared/components/dataFilePanel/DataFilePanel";

const ProfileDataFileParser = ({ profileActions: { updateProfileField }, fileActions: { updateFileInformation }, onDropFiles, ...props }) => {
  const getFileInformation = files =>
    files.length === 1
      ? {
        fileName: files[0].name,
        fileExtension: files[0].name.split(".").pop()
      }
      : { fileName: "", fileExtension: "" };

  const handleDropFiles = (acceptedFiles, rejectedFiles) => {
    const fileInformation = getFileInformation(acceptedFiles);
    updateProfileField('transformedFileType', fileInformation.fileExtension);
    updateFileInformation(fileInformation);
    onDropFiles(acceptedFiles, rejectedFiles);
  };

  return (
    <DataFileUploadPanel title={ `2. Select Data File` } onDropFiles={ handleDropFiles } { ...props } />
  );
};

ProfileDataFileParser.propTypes = {
  onDropFiles: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  profileActions: PropTypes.shape({
    updateProfileField: PropTypes.func
  }).isRequired,
  fileActions: PropTypes.shape({
    updateFileInformation: PropTypes.func
  }).isRequired
};

ProfileDataFileParser.defaultProps = {
  disabled: false,
  loading: false
};

export default ProfileDataFileParser;




// WEBPACK FOOTER //
// ./src/components/importProfile/comp/profileDataFileParser/ProfileDataFileParser.js